module.exports = __webpack_public_path__ + "static/media/pray.e3089f77.svg";